(function () {
  function initGallery(root) {
    if (!root || root.dataset.galleryInit === '1') return;
    root.dataset.galleryInit = '1';

    const buttons = Array.from(root.querySelectorAll('.landing-page-gallery__filter'));
    const dropdownToggle = root.querySelector('.landing-page-gallery__filters-toggle');
    const dropdownPanel = root.querySelector('.landing-page-gallery__filters-panel');
    const dropdownOptions = Array.from(root.querySelectorAll('.landing-page-gallery__filters-option'));
    const dropdownValue = root.querySelector('.landing-page-gallery__filters-value');
    const items = Array.from(root.querySelectorAll('.landing-page-gallery__item'));
    const lightbox = root.querySelector('.landing-page-gallery__lightbox');
    const lightboxMedia = root.querySelector('.landing-page-gallery__lightbox-media');
    const lightboxImage = root.querySelector('.landing-page-gallery__lightbox-image');
    const lightboxHeading = root.querySelector('.landing-page-gallery__lightbox-heading');
    const lightboxSubheading = root.querySelector('.landing-page-gallery__lightbox-subheading');
    const lightboxCaption = root.querySelector('.landing-page-gallery__lightbox-caption');
    const lightboxDesktopCta = root.querySelector('.landing-page-gallery__lightbox-cta--desktop');
    const lightboxPrevButtons = Array.from(root.querySelectorAll('[data-lightbox-prev]'));
    const lightboxNextButtons = Array.from(root.querySelectorAll('[data-lightbox-next]'));
    const lightboxCloseButtons = Array.from(root.querySelectorAll('[data-lightbox-close]'));

    let currentItems = [];
    let currentIndex = 0;
    let pendingLoadId = 0;

    const preloadImage = (src, srcset, sizes) => {
      if (!src && !srcset) return;
      const img = new Image();
      if (sizes) img.sizes = sizes;
      if (srcset) img.srcset = srcset;
      if (src) img.src = src;
    };

    const getVisibleItems = () =>
      items.filter((item) => item.offsetParent !== null);

    const setActive = (target) => {
      buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn === target);
      });
    };

    const applyFilter = (filter) => {
      items.forEach((item) => {
        const match = filter === 'all' || item.dataset.gallery === filter;
        item.style.display = match ? '' : 'none';
      });
    };

    const updateDropdownLabel = (label) => {
      if (!dropdownValue) return;
      dropdownValue.textContent = label || 'All';
    };

    const updateUrlFilter = (filter) => {
      try {
        const url = new URL(window.location.href);
        if (filter && filter !== 'all') {
          url.searchParams.set('gallery', filter);
        } else {
          url.searchParams.delete('gallery');
        }
        window.history.pushState({}, '', url.toString());
      } catch (error) {
        // No-op if URL API is unavailable.
      }
    };

    const applyFilterSelection = (filter, label) => {
      const targetFilter = filter || 'all';
      const buttonTarget = buttons.find((btn) => btn.dataset.filter === targetFilter);
      if (buttonTarget) setActive(buttonTarget);
      applyFilter(targetFilter);

      const option = dropdownOptions.find((opt) => opt.dataset.filter === targetFilter);
      if (option) {
        dropdownOptions.forEach((opt) => opt.classList.remove('is-active'));
        option.classList.add('is-active');
        updateDropdownLabel(option.textContent.trim());
      } else if (label) {
        updateDropdownLabel(label);
      }
    };

    const closeDropdown = () => {
      if (!dropdownToggle || !dropdownPanel) return;
      dropdownPanel.classList.remove('is-open');
      dropdownToggle.setAttribute('aria-expanded', 'false');
    };

    const openDropdown = () => {
      if (!dropdownToggle || !dropdownPanel) return;
      dropdownPanel.classList.add('is-open');
      dropdownToggle.setAttribute('aria-expanded', 'true');
    };

    const updateLightboxNav = () => {
      if (!lightboxPrevButtons.length || !lightboxNextButtons.length) return;
      const prevDisplay = currentIndex === 0 ? 'none' : '';
      const nextDisplay = currentIndex === currentItems.length - 1 ? 'none' : '';
      lightboxPrevButtons.forEach((btn) => {
        btn.style.display = prevDisplay;
      });
      lightboxNextButtons.forEach((btn) => {
        btn.style.display = nextDisplay;
      });
    };

    const renderLightbox = (item) => {
      if (!lightboxImage || !item) return;
      const loadId = (pendingLoadId += 1);
      const img = item.querySelector('img');
      const full = item.dataset.full || '';
      const fullSrcset = item.dataset.fullSrcset || '';
      const fullWidth = item.dataset.fullWidth || '';
      const fullHeight = item.dataset.fullHeight || '';
      const heading = item.dataset.heading || '';
      const subheadingNode = item.querySelector('.landing-page-gallery__subheading-html');
      const subheading = subheadingNode ? subheadingNode.innerHTML : '';

      const resolvedSrc = full || (img && img.src) || '';
      const resolvedSrcset = fullSrcset || (img && img.srcset) || '';
      lightboxImage.classList.add('is-loading');
      if (lightboxMedia) lightboxMedia.classList.add('is-loading');
      lightboxImage.src = resolvedSrc;
      lightboxImage.srcset = resolvedSrcset;
      lightboxImage.sizes = resolvedSrcset ? '100vw' : '';
      lightboxImage.width = fullWidth || (img && img.width) || '';
      lightboxImage.height = fullHeight || (img && img.height) || '';
      lightboxImage.alt = (img && img.alt) || '';
      lightboxImage.decoding = 'async';

      const onLoad = () => {
        if (loadId !== pendingLoadId) return;
        lightboxImage.classList.remove('is-loading');
        if (lightboxMedia) lightboxMedia.classList.remove('is-loading');
      };
      if (lightboxImage.complete) {
        onLoad();
      } else {
        lightboxImage.addEventListener('load', onLoad, { once: true });
      }

      if (lightboxHeading) {
        lightboxHeading.textContent = heading;
        lightboxHeading.style.display = heading ? '' : 'none';
      }

      if (lightboxSubheading) {
        lightboxSubheading.innerHTML = subheading;
        lightboxSubheading.style.display = subheading ? '' : 'none';
      }

      if (lightboxCaption) {
        const hasDesktopCta = Boolean(
          lightboxDesktopCta && lightboxDesktopCta.textContent.trim()
        );
        const hasCaption = Boolean(heading || subheading || hasDesktopCta);
        lightboxCaption.style.display = hasCaption ? '' : 'none';
      }

      updateLightboxNav();
    };

    const preloadNeighbors = () => {
      const prev = currentItems[currentIndex - 1];
      const next = currentItems[currentIndex + 1];
      const itemsToPreload = [prev, next].filter(Boolean);
      itemsToPreload.forEach((item) => {
        const img = item.querySelector('img');
        const full = item.dataset.full || '';
        const fullSrcset = item.dataset.fullSrcset || '';
        const resolvedSrc = full || (img && img.src) || '';
        const resolvedSrcset = fullSrcset || (img && img.srcset) || '';
        preloadImage(resolvedSrc, resolvedSrcset, resolvedSrcset ? '100vw' : '');
      });
    };

    const openLightbox = (item) => {
      if (!lightbox || !item) return;
      currentItems = getVisibleItems();
      currentIndex = Math.max(0, currentItems.indexOf(item));
      renderLightbox(currentItems[currentIndex]);
      preloadNeighbors();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('landing-page-gallery--lock');
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('landing-page-gallery--lock');
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.filter;
        applyFilterSelection(filter, btn.textContent.trim());
        updateUrlFilter(filter);
      });
    });

    if (dropdownToggle && dropdownPanel) {
      dropdownToggle.addEventListener('click', () => {
        const isOpen = dropdownPanel.classList.contains('is-open');
        if (isOpen) {
          closeDropdown();
        } else {
          openDropdown();
        }
      });
    }

    dropdownOptions.forEach((option) => {
      option.addEventListener('click', () => {
        const filter = option.dataset.filter;
        applyFilterSelection(filter, option.textContent.trim());
        updateUrlFilter(filter);
        closeDropdown();
      });
    });

    document.addEventListener('click', (event) => {
      if (!dropdownToggle || !dropdownPanel) return;
      if (dropdownPanel.contains(event.target) || dropdownToggle.contains(event.target)) return;
      closeDropdown();
    });

    updateDropdownLabel(dropdownOptions[0] ? dropdownOptions[0].textContent.trim() : 'All');

    const initialFilter = (() => {
      try {
        const params = new URLSearchParams(window.location.search);
        return params.get('gallery');
      } catch (error) {
        return null;
      }
    })();

    if (initialFilter) {
      const exists =
        buttons.some((btn) => btn.dataset.filter === initialFilter) ||
        dropdownOptions.some((opt) => opt.dataset.filter === initialFilter);
      if (exists) {
        applyFilterSelection(initialFilter);
      }
    }

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('.landing-page-gallery__trigger');
      if (!trigger) return;
      const item = trigger.closest('.landing-page-gallery__item');
      openLightbox(item);
    });

    lightboxPrevButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (currentIndex <= 0) return;
        currentIndex -= 1;
        renderLightbox(currentItems[currentIndex]);
        preloadNeighbors();
      });
    });

    lightboxNextButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (currentIndex >= currentItems.length - 1) return;
        currentIndex += 1;
        renderLightbox(currentItems[currentIndex]);
        preloadNeighbors();
      });
    });

    lightboxCloseButtons.forEach((btn) => {
      btn.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft' && currentIndex > 0) {
        currentIndex -= 1;
        renderLightbox(currentItems[currentIndex]);
        preloadNeighbors();
      }
      if (event.key === 'ArrowRight' && currentIndex < currentItems.length - 1) {
        currentIndex += 1;
        renderLightbox(currentItems[currentIndex]);
        preloadNeighbors();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = Array.from(document.querySelectorAll('.landing-page-gallery'));
    sections.forEach(initGallery);
  });
})();
